import type { ReactNode } from 'react'

interface HomeHeaderProps {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
}

export function HomeHeader({ title, subtitle, actions }: HomeHeaderProps) {
  return (
    <div className="home-header">
      <div>
        <h1 className="text-2xl font-bold">{title}</h1>
        {subtitle ? <div className="text-gray-400 text-sm mt-1">{subtitle}</div> : null}
      </div>
      {actions ? <div className="home-header-actions">{actions}</div> : null}
    </div>
  )
}
